<template>
  <div class="Download">
    <img src="../assets/logo.png" class="logo" />
    <div class="qcode_m" v-if="userId == 288">
      <img src="../assets/qCode.png" />
    </div>
    <div class="btns pof">
      <div class="ios tac f36" @click="download(1)">
        <img src="../assets/ios.png" />
        IOS版下载
      </div>
      <div class="and tac f36" @click="download(0)">
        <img src="../assets/Android.png" />
        Android版下载
      </div>
    </div>
  </div>
</template>

<script>
import { post } from "../api/axios";

export default {
  name: "Download",
  data() {
    return {
      userId: "",
    };
  },
  methods: {
    download(appSystem) {
      let params = {
        appSystem,
      };
      post("boot-app/api/v2/app/fzdAppVersion/findNewVersion", params)
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            let a = document.createElement("a");
            a.href = res.data;
            a.click();
          } else {
            this.$message(res.message);
          }
        })
        .catch((err) => {
          this.$message(err);
        });
    },
  },
  mounted() {
    document.title = "分之道APP下载";
    this.userId = this.$route.query.userId;
  },
};
</script>

<style scoped lang="scss">
.Download {
  background-image: url("../assets/down_bg.png");
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: 0 bottom;
  .logo {
    padding-top: 284px;
    width: 34%;
    height: auto;
  }
  .qcode_m {
    margin-top: 2rem;
    text-align: center;
    img {
      width: 32%;
      height: 32%;
    }
  }

  .btns {
    bottom: 180px;
    width: 100%;

    div {
      width: 480px;
      height: 100px;
      line-height: 100px;
      border: 2px solid #fff;
      border-radius: 50px;
      color: #fff;
      margin: 60px auto 0;

      img {
        width: 38px;
        height: 46px;
        margin-right: 22px;
        vertical-align: text-bottom;
      }
    }
  }
}
</style>
